import React from 'react';
import { Link } from 'gatsby';
import PFFBusinessIcon from '../../icons/pff-for-business.svg';

const BusinessHeader2024 = () => (
  <div className="bg-navy-400 py-5 px-10 flex justify-between items-center">
    <div className="container flex flex-row justify-between items-center">
      <Link to="/business">
        <PFFBusinessIcon className="h-[70px] w-[140px] relative top-[4px]" />
      </Link>

      <Link
        to="/business/contact"
        className="bg-[#E04613] font-brown tracking-[2.16px] text-white text-[12px] px-6 py-3 uppercase rounded-[28px]"
      >
        Contact Us
      </Link>
    </div>
  </div>
);

export default BusinessHeader2024;
